import React, { useState, useRef, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import Flex from "../../designLayouts/Flex";
import { useNavigate, useLocation } from "react-router-dom";
import { allproduct } from "../../../constants";
import "../../../assets/font.css";

const HeaderBottom = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const ref = useRef();
  const location = useLocation();
  useEffect(() => {
    document.body.addEventListener("click", (e) => {
      if (ref.current && ref.current.contains(e.target)) {
        setShow(true);
      } else {
        setShow(false);
      }
    });
  }, [show, ref]);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const filtered = allproduct.filter((item) =>
      item.productName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredProducts(filtered);
  }, [searchQuery]);

  const isHomePage = location.pathname === "/";

  return (
    <div className="w-full bg-[#F5F5F3] relative">
      <div className="max-w-container mx-auto">
      {!isHomePage && (
        <Flex className="flex flex-col lg:flex-row items-start lg:items-center justify-between w-full px-4 pb-4 lg:pb-0 h-full lg:h-24">
          <div
            onClick={() => setShow(!show)}
            ref={ref}
            className="flex h-14 cursor-pointer items-center gap-2 text-primeColor"
          >
          </div>
          <div className="relative w-full lg:w-[600px] h-[50px] text-base text-primeColor bg-white flex items-center justify-center gap-2 px-6 rounded-xl">            
          <input
              className="kanit-medium text-[#ff9800] flex-1 h-full outline-none placeholder:text-[#C4C4C4] placeholder:text-[14px]"
              type="text"
              onChange={handleSearch}
              value={searchQuery}
              placeholder="ค้นหาสินค้า"
            />
            <FaSearch className="w-5 h-5 text-[#C4C4C4] hover:text-[#ff9800]" />
            {searchQuery && (
              <div
                className={`w-full mx-auto h-96 bg-white top-16 absolute left-0 z-50 overflow-y-scroll shadow-2xl scrollbar-hide cursor-pointer`}
              >
                {searchQuery &&
                  filteredProducts.map((item) => (
                    <div
                      onClick={() =>
                        navigate(
                          `/product/${item.productName
                            .toLowerCase()
                            .split(" ")
                            .join("")}`,
                          {
                            state: {
                              item: item,
                            },
                          }
                        ) &
                        setShowSearchBar(true) &
                        setSearchQuery("")
                      }
                      key={item._id}
                      className="max-w-[600px] h-28 bg-gray-100 mb-3 flex items-center gap-3"
                    >
                      <img className="w-24" src={item.img} alt="productImg" />
                      <div className="flex flex-col gap-1">
                        <p className="kanit-semibold text-lg text-[#154360] hover:text-[#ff9800]">
                          {item.productName}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </Flex>
        )}
      </div>
    </div>
  );
};

export default HeaderBottom;
